
/**
 * Unicode символ неразрывного пробела
 */
export const UNICODE_NON_BREAKING_SPACE = '\u00A0';

/**
 * Функция, которая заменяет обычные пробелы в числовых и валютных последовательностях на неразрывные пробелы.
 *
 * @param text исходный текст
 * @returns текст с неразрывными пробелами в числовых и валютных выражениях
 *
 * @category Formatters
 *
 * @example
 * formatTextWithNumbers("Ваш баланс 1 500 000,00 ₽") // "Ваш баланс 1\u00A0500\u00A0000,00\u00A0₽"
 */
export default function formatTextWithNumbers(text: string | undefined): string {
    if (!text) {
        return '';
    }

    // Используем Unicode символ неразрывного пробела \u00A0 вместо HTML-сущности &nbsp;

    // Замена пробелов в числовых и валютных последовательностях на неразрывные пробелы
    const digitWithCurrency = /(\d+(?:[ \u00A0]+\d+)*(?:,\d+)?)\s+((?:тыс\.?|млн\.?|млрд\.?|руб\.?|рубл[ьяей]|₽))/gi;
    let result = text.replace(digitWithCurrency, (match) => match.replace(/\s/g, UNICODE_NON_BREAKING_SPACE));

    // Обработка пар единиц измерения: "тыс руб", "млн ₽" и т.д.
    const currencyPairs = /(тыс\.?|млн\.?|млрд\.?)\s+(руб\.?|рубл[ьяей]|₽)/gi;
    result = result.replace(currencyPairs, (match) => match.replace(/\s/g, UNICODE_NON_BREAKING_SPACE));

    // Обработка групп цифр с пробелами между ними
    const numberGroups = /(\d{1,3})\s+(\d{3})(?:\s+\d{3})*/g;
    result = result.replace(numberGroups, (match) => match.replace(/\s/g, UNICODE_NON_BREAKING_SPACE));

    // Дополнительная обработка для случаев, когда валюта отделена от числа пробелом
    const numberWithSeparatedCurrency = /(\d+(?:,\d+)?)\s+(₽|руб\.?|рубл[ьяей])/gi;
    result = result.replace(numberWithSeparatedCurrency, (match) => match.replace(/\s/g, UNICODE_NON_BREAKING_SPACE));

    return result;
};